if (!customElements.get('bh-load-more')) {
  customElements.define(
    'bh-load-more',
    class BHLoadMore extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.status = this.querySelector('[data-load-more-status]');
        this.onClick = this.loadNextPage.bind(this);
        this.button?.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onClick);
        this.controller?.abort();
      }

      async loadNextPage() {
        if (!this.button || this.button.disabled || !this.dataset.nextUrl) return;

        const productGrid = document.getElementById('product-grid');
        if (!productGrid) return;

        this.setLoading(true);
        this.controller = new AbortController();

        try {
          const requestUrl = new URL(this.dataset.nextUrl, window.location.origin);
          requestUrl.searchParams.set('section_id', this.dataset.sectionId);

          const response = await fetch(requestUrl.toString(), {
            signal: this.controller.signal,
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
          });

          if (!response.ok) throw new Error(`HTTP ${response.status}`);

          const html = await response.text();
          const parsedDocument = new DOMParser().parseFromString(html, 'text/html');
          const fetchedGrid = parsedDocument.getElementById('product-grid');

          if (!fetchedGrid) throw new Error('Product grid was not found in the response.');

          const newItems = Array.from(fetchedGrid.children);
          const fragment = document.createDocumentFragment();

          newItems.forEach((item) => {
            item.classList.add('scroll-trigger--cancel');
            fragment.appendChild(item);
          });

          productGrid.appendChild(fragment);

          if (window.BHWishlist?.refresh) window.BHWishlist.refresh();

          if (this.status) {
            this.status.textContent = this.dataset.loadedLabel.replace('{count}', String(newItems.length));
          }

          const nextControl = parsedDocument.querySelector('bh-load-more[data-next-url]');

          if (nextControl?.dataset.nextUrl) {
            this.dataset.nextUrl = nextControl.dataset.nextUrl;
            this.setLoading(false);
          } else {
            this.button.remove();
            this.classList.add('is-complete');
            delete this.dataset.nextUrl;
          }
        } catch (error) {
          if (error.name === 'AbortError') return;

          this.setLoading(false);
          if (this.status) this.status.textContent = this.dataset.errorLabel;
          console.error('BH Load More:', error);
        }
      }

      setLoading(isLoading) {
        this.button.disabled = isLoading;
        this.button.classList.toggle('loading', isLoading);
        this.button.setAttribute('aria-busy', String(isLoading));

        if (isLoading) {
          this.button.setAttribute('aria-label', this.dataset.loadingLabel);
        } else {
          this.button.removeAttribute('aria-label');
        }

        const spinner = this.button.querySelector('.loading__spinner');
        spinner?.classList.toggle('hidden', !isLoading);
      }
    }
  );
}
